// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/result/style/index.less
// module id = 186
// module chunks = 0